import React from "react"
import Accordion from "@material-ui/core/Accordion"

const EP = ({ title, children, ...rest }) => {
  return <Accordion {...rest}>{children}</Accordion>
}

export default EP
